import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">WVAesthetics · Elevate Your Beauty</p>
        <h1>Transform Your Look with WVAesthetics</h1>
        <p className="lede">
          Discover a world of beauty and wellness tailored just for you. At WVAesthetics, we offer a range of services designed to enhance your natural beauty and boost your confidence.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Personalized Treatments</h2>
          <p>
            Our expert team provides customized aesthetic solutions to meet your unique needs and goals.
          </p>
        </article>
        <article>
          <h2>State-of-the-Art Technology</h2>
          <p>
            We utilize the latest advancements in beauty technology to ensure safe and effective results.
          </p>
        </article>
        <article>
          <h2>Commitment to Excellence</h2>
          <p>
            Experience unparalleled service and care in a welcoming environment dedicated to your satisfaction.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;